import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import './TopHolding.css';
import Slider from 'react-slick';
// import marketup from '../../Images/arrow-up.png';
// import marketdown from '../../../Images/Images/arrow-down.png';
import { useNavigate } from "react-router-dom";
import Pagination from '../../CommonUI/Pagination/Pagination';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'



function TopHolding() {
    const { BaseURL } = useContext(URLstateContext);
    const [DataHolding, setDataHolding] = useState([]);
    const [DataMfHoldingdrop, setDataMfHoldingdrop] = useState([]);
    const [DataMfHoldingdropcat, setDataMfHoldingdropcat] = useState([]);
    const [Category, setCategory] = useState('5946');
    const [Sheme, setSheme] = useState('26');
    const [ShemeCode, setShemeCode] = useState('10645');
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    const [valuecategory, setValuecategory] = useState([]);
    const [valuecategory1, setValuecategory1] = useState([]);
    const [valuecategory2, setValuecategory2] = useState([]);
    const [DataMfHoldingdropSheme, setDataMfHoldingdropSheme] = useState([]);

    let getDataHolding, getDataHoldingdrop,
        getDataHoldingdropcat, getDataHoldingdropSheme;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true);
        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";

        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdrop) => {
                getDataHoldingdrop = dataMHoldingdrop.data;
                setDataMfHoldingdrop(getDataHoldingdrop);
                setloadingshow(false);

            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropcat) => {
                getDataHoldingdropcat = dataMHoldingdropcat.data;
                setDataMfHoldingdropcat(getDataHoldingdropcat);
                setloadingshow(false);
            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropSheme) => {
                getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                setloadingshow(false);
                // console.log(codename)

            })
            .catch((error) => {
            });

        const getUrlMfTopHolding = BaseURL + "MfTopHolding";

        fetch(`${getUrlMfTopHolding}/${ShemeCode}/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHolding = dataMHolding.data;
                setDataHolding(getDataHolding);
                setloadingshow(false);
                //console.log(getDataHolding, "MfTopHolding")
            })
            .catch((error) => {
            });
    }, [Category, Sheme, ShemeCode]);

    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";

        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdrop) => {
                getDataHoldingdrop = dataMHoldingdrop.data;
                setDataMfHoldingdrop(getDataHoldingdrop);
                setloadingshow(false);
                var codename = getDataHoldingdrop[0].co_name;

                setValuecategory(codename)


            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropcat) => {
                getDataHoldingdropcat = dataMHoldingdropcat.data;
                setDataMfHoldingdropcat(getDataHoldingdropcat);
                setloadingshow(false);

                var codename = getDataHoldingdropcat[0].VCLASS;
                setValuecategory1(codename)


            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropSheme) => {
                getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                setloadingshow(false);
                var codename = getDataHoldingdropSheme[0].SCH_NAME;
                setValuecategory2(codename)

                // console.log(codename)

            })
            .catch((error) => {
            });

        const getUrlMfTopHolding = BaseURL + "MfTopHolding";

        fetch(`${getUrlMfTopHolding}/${ShemeCode}/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHolding = dataMHolding.data;
                setDataHolding(getDataHolding);
                setloadingshow(false);
                //console.log(getDataHolding, "MfTopHolding")
            })
            .catch((error) => {
            });
    }, []);


    const currentTableData = useMemo(() => {
        if (DataHolding != null && DataHolding != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataHolding != null && DataHolding != []) {
                if (DataHolding.length > 0) {
                    return DataHolding.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataHolding]);

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Top 10 Holdings</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='topHold-loser-sc'>

                            <div className='topHold-header'>

                                <h2><span>Top 10 Holdings</span></h2>
                            </div>
                            <MarketMF optionValue="Top 10 Holding" />
                            <div className='topHold-right'>
                                <div className='Hold-inner-select'>

                                    <select onChange={(event) => { setCategory(event.target.value); setValuecategory1('selectCategory'); document.getElementById("select-cat").selectedIndex = "0"; }}>
                                        <option>Select Fund House</option>
                                        {DataMfHoldingdrop && DataMfHoldingdrop.map(
                                            ({ mf_cocode, co_name }) => (
                                                <option value={mf_cocode} selected={valuecategory === co_name}>{co_name}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='topHold-inner-select'>
                                    <select id="select-cat" onChange={(event) => { setSheme(event.target.value); setValuecategory2('selectScheme'); document.getElementById("select-sch").selectedIndex = "0"; }}>
                                        <option id='selectCategory'>Select Category</option>
                                        {DataMfHoldingdropcat && DataMfHoldingdropcat.map(
                                            ({ VCLASSCODE, VCLASS }) => (

                                                <option value={VCLASSCODE} selected={valuecategory1 === VCLASS || valuecategory1 === "selectCategory"}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='topHold-inner-select'>
                                    <select id="select-sch" onChange={(event) => setShemeCode(event.target.value)}>
                                        <option id="selectScheme">Select Scheme</option>
                                        {DataMfHoldingdropSheme && DataMfHoldingdropSheme.map(
                                            ({ MF_SCHCODE, SCH_NAME }) => (

                                                <option value={MF_SCHCODE} selected={valuecategory2 === SCH_NAME || valuecategory2 === "selectScheme"}>{SCH_NAME}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='topHold-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-right'>% Hold</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ co_code, co_name, Perc_hold }) => (
                                                <tr>
                                                    <td className='text-left'>{co_name}</td>
                                                    <td className='text-right'>{Perc_hold.toFixed(2)}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>

                            {(DataHolding != null && DataHolding != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(DataHolding.length != null) ? DataHolding.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default TopHolding